"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var FormItem_1 = __importDefault(require("../FormItem"));
var MapBox_1 = __importDefault(require("../../../Map/MapBox"));
var Mapv2_1 = __importDefault(require("../../../Mapv2"));
var TextInput_1 = __importDefault(require("../TextInput"));
var Select_1 = __importDefault(require("../Select"));
var styles_1 = require("./styles");
var transifex_1 = require("../../../../transifex");
var LocationInput = function (_a) {
    var _b, _c, _d, _e;
    var value = _a.value, _mapBoxProps = _a.mapBoxProps, onChange = _a.onChange, antd = _a.antd, error = _a.error, viewData = _a.viewData, _f = _a.viewMode, viewMode = _f === void 0 ? false : _f;
    var _g = react_1.useState(true), useGeoCoder = _g[0], setUseGeoCoder = _g[1];
    var _h = react_1.useState(false), manualLatLng = _h[0], setManualLatLng = _h[1];
    var handleValueOnChange = function (result) {
        onChange === null || onChange === void 0 ? void 0 : onChange({
            longitude: result.longitude || (value === null || value === void 0 ? void 0 : value.longitude) || 0,
            latitude: result.latitude || (value === null || value === void 0 ? void 0 : value.latitude) || 0,
            name: result.name || (value === null || value === void 0 ? void 0 : value.name) || "",
        });
    };
    var mapBoxProps = __assign(__assign({}, _mapBoxProps), { isLocationInput: true, controls: __assign(__assign({}, _mapBoxProps === null || _mapBoxProps === void 0 ? void 0 : _mapBoxProps.controls), { geoCoder: {
                accessToken: "123",
                types: "address",
            }, geoCoderUpdateName: useGeoCoder, onGeoCode: handleValueOnChange }), initialPosition: value
            ? {
                name: value.name,
                longitude: value.longitude,
                latitude: value.latitude,
            }
            : undefined, center: {
            longitude: (value === null || value === void 0 ? void 0 : value.longitude) || ((_b = _mapBoxProps === null || _mapBoxProps === void 0 ? void 0 : _mapBoxProps.center) === null || _b === void 0 ? void 0 : _b.longitude) || 10.2128,
            latitude: (value === null || value === void 0 ? void 0 : value.latitude) || ((_c = _mapBoxProps === null || _mapBoxProps === void 0 ? void 0 : _mapBoxProps.center) === null || _c === void 0 ? void 0 : _c.latitude) || 56.1523,
        }, zoom: (_mapBoxProps === null || _mapBoxProps === void 0 ? void 0 : _mapBoxProps.zoom) || 15 });
    var viewMapBoxProps = __assign(__assign({}, _mapBoxProps), { center: {
            longitude: (value === null || value === void 0 ? void 0 : value.longitude) || ((_d = _mapBoxProps === null || _mapBoxProps === void 0 ? void 0 : _mapBoxProps.center) === null || _d === void 0 ? void 0 : _d.longitude) || 10.2128,
            latitude: (value === null || value === void 0 ? void 0 : value.latitude) || ((_e = _mapBoxProps === null || _mapBoxProps === void 0 ? void 0 : _mapBoxProps.center) === null || _e === void 0 ? void 0 : _e.latitude) || 56.1523,
        }, zoom: (_mapBoxProps === null || _mapBoxProps === void 0 ? void 0 : _mapBoxProps.zoom) || 8 });
    var txRequiredField = transifex_1.useTxStrings().txRequiredField;
    var TYPE = [
        { label: transifex_1.TX_SEARCH, value: "search" },
        { label: transifex_1.TX_MANUAL, value: "manual" },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FormItem_1.default, { antd: antd, error: error ? txRequiredField() : error },
            react_1.default.createElement(styles_1.FormItemNoMargin, null,
                react_1.default.createElement(antd_1.Input.Group, { compact: true },
                    react_1.default.createElement(Select_1.default, { style: { width: "30%" }, defaultValue: "search", antd: { noStyle: true }, disabled: false, options: TYPE, onChange: function () {
                            setUseGeoCoder(function (prevState) { return !prevState; });
                        } }),
                    react_1.default.createElement(TextInput_1.default, { style: { width: "70%" }, value: value === null || value === void 0 ? void 0 : value.name, disabled: useGeoCoder, antd: { noStyle: true }, onChange: function (e) {
                            return handleValueOnChange(__assign(__assign({}, value), { name: e.currentTarget.value }));
                        } })),
                !useGeoCoder && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("small", null,
                        react_1.default.createElement(antd_1.Typography.Text, { onClick: function () { return setManualLatLng(function (prevState) { return !prevState; }); }, style: { color: "#1890ff", cursor: "pointer" } }, manualLatLng ? transifex_1.TX_HIDE_LAT_LONG : transifex_1.TX_SHOW_LAT_LONG)),
                    manualLatLng && (react_1.default.createElement("div", { className: "ant-form ant-form-vertical", style: { paddingTop: "1rem" } },
                        react_1.default.createElement(antd_1.Input.Group, { compact: true },
                            react_1.default.createElement(TextInput_1.default, { value: value === null || value === void 0 ? void 0 : value.latitude, disabled: useGeoCoder, antd: {
                                    label: transifex_1.TX_LATITUDE,
                                    style: { width: "50%", paddingRight: "1rem" },
                                }, allowClear: true, type: "number", onChange: function (e) {
                                    var latitude = parseFloat(e.currentTarget.value || "0");
                                    if (latitude >= -90 && latitude <= 90) {
                                        handleValueOnChange(__assign(__assign({}, value), { latitude: latitude }));
                                    }
                                } }),
                            react_1.default.createElement(TextInput_1.default, { value: value === null || value === void 0 ? void 0 : value.longitude, antd: {
                                    label: transifex_1.TX_LONGITUDE,
                                    style: { width: "50%" },
                                }, type: "number", allowClear: true, onChange: function (e) {
                                    var longitude = parseFloat(e.currentTarget.value || "0");
                                    if (longitude >= -180 && longitude <= 180) {
                                        handleValueOnChange(__assign(__assign({}, value), { longitude: longitude }));
                                    }
                                } }))))))),
            !viewMode && (react_1.default.createElement("div", { style: { paddingTop: "1rem" } },
                react_1.default.createElement(MapBox_1.default, __assign({}, mapBoxProps)))),
            viewMode && viewData && (react_1.default.createElement("div", { style: { paddingTop: "1rem" } },
                react_1.default.createElement(Mapv2_1.default, { mapBoxProps: viewMapBoxProps, data: viewData }))))));
};
exports.default = LocationInput;
